export interface HomepageSeo {
	title: ComputedRef<string>;
	description: ComputedRef<string>;
}

export function useHomepageSeo(): HomepageSeo {
	const title = computed(
		() => 'Imóveis de Alto Padrão à venda em SP e Curitiba - PilarHomes'
	);
	const description = computed(
		() =>
			'Encontre casas e apartamentos nos endereços desejados de SP e Curitiba. Compre com o líder do segmento de luxo: curadoria exclusiva, sem anúncios repetidos.'
	);

	return {
		title,
		description
	};
}
